import * as yup from 'yup';
import { isValidYupSchema, yupUtils } from '../../utils/yup/utils';
import { PriceTier } from '../types/priceTier';
import { ProjectErrors, ProjectErrorType } from '../../utils/errors/types';
import { getProjectErrorForCode, getProjectErrorFromRawError, isProjectError } from '../../utils/errors';

export const PriceTierSchema = yup.object().shape({
  name: yupUtils.stringRequired(),
  productId: yupUtils.stringRequired(),
});

const processPriceTier = async (priceTier: any): Promise<PriceTier> => {
  return {
    ...priceTier,
  };
};

export const parsePriceTier = async (object: any): Promise<PriceTier | ProjectErrorType> => {
  try {
    if (await isValidYupSchema(PriceTierSchema, object)) {
      return processPriceTier(object as PriceTier);
    }
    return getProjectErrorForCode(ProjectErrors.invalidAuthor);
  } catch (error) {
    console.log(`[PRICE TIERS] Price Tier: ${object}. Error:`, error);
    return getProjectErrorFromRawError(error as Error);
  }
};

export const parsePriceTiers = async (item: any): Promise<PriceTier[]> => {
  if (!item || !('tiers' in item)) {
    console.log('[PRICE TIERS] Error: Not found.');
    return [];
  }

  const data: PriceTier[] = [];
  for (const tier of item?.tiers) {
    const o = await parsePriceTier(tier);
    if (o && !isProjectError(o)) {
      data.push(o as PriceTier);
    }
  }

  return data;
};
